"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Parser = void 0;
const Scanner_1 = require("./Scanner");
const RowParser_1 = require("./RowParser");
const Token_1 = require("./Token");
class Parser {
  constructor(parserOptions) {
    this.parserOptions = parserOptions;
    this.rowParser = new RowParser_1.RowParser(this.parserOptions);
  }
  static removeBOM(line) {
    // Catches EFBBBF (UTF-8 BOM) because the buffer-to-string
    // conversion translates it to FEFF (UTF-16 BOM)
    if (line && line.charCodeAt(0) === 0xfeff) {
      return line.slice(1);
    }
    return line;
  }
  parse(line, hasMoreData) {
    const scanner = new Scanner_1.Scanner({
      line: Parser.removeBOM(line),
      parserOptions: this.parserOptions,
      hasMoreData
    });
    if (this.parserOptions.supportsComments) {
      return this.parseWithComments(scanner);
    }
    return this.parseWithoutComments(scanner);
  }
  parseWithoutComments(scanner) {
    const rows = [];
    let shouldContinue = true;
    while (shouldContinue) {
      shouldContinue = this.parseRow(scanner, rows);
    }
    return {
      line: scanner.line,
      rows
    };
  }
  parseWithComments(scanner) {
    const {
      parserOptions
    } = this;
    const rows = [];
    for (let nextToken = scanner.nextCharacterToken; nextToken !== null; nextToken = scanner.nextCharacterToken) {
      if (Token_1.Token.isTokenComment(nextToken, parserOptions)) {
        const cursor = scanner.advancePastLine();
        if (cursor === null) {
          return {
            line: scanner.lineFromCursor,
            rows
          };
        }
        if (!scanner.hasMoreCharacters) {
          return {
            line: scanner.lineFromCursor,
            rows
          };
        }
        scanner.truncateToCursor();
      } else if (!this.parseRow(scanner, rows)) {
        break;
      }
    }
    return {
      line: scanner.line,
      rows
    };
  }
  parseRow(scanner, rows) {
    const nextToken = scanner.nextNonSpaceToken;
    if (!nextToken) {
      return false;
    }
    const row = this.rowParser.parse(scanner);
    if (row === null) {
      return false;
    }
    if (this.parserOptions.ignoreEmpty && RowParser_1.RowParser.isEmptyRow(row)) {
      return true;
    }
    rows.push(row);
    return true;
  }
}
exports.Parser = Parser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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